'use strict'; // const TopBar = document.querySelector('header');

/**
 * Shrink top bar on scroll
 */
// window.addEventListener('scroll', () => {
//
//     let position = window.pageYOffset | document.body.scrollTop;
//
//     if( position >= 92 ) {
//         if( ! TopBar.classList.contains('header--slim') ) {
//             TopBar.classList.add('header--slim');
//         }
//     } else if( position < 92 ) {
//         if( TopBar.classList.contains('header--slim') ) {
//             TopBar.classList.remove('header--slim');
//         }
//     }
//
// });

/**
 * Shrink top bar on page load
 */
// window.addEventListener('load', () => {
//
//     let position = window.pageYOffset | document.body.scrollTop;
//
//     if( position >= 92 ) {
//         if (!TopBar.classList.contains('header--slim')) {
//             TopBar.classList.add('header--slim');
//         }
//     }
//
// });